import React, { useEffect } from "react";
import Styled from "./DeviceLimitStyles";
import { Color, ColorSAP, FONT_FAMILY, Typography } from "../../ontego-ui";
import Chart from "../Chart/Chart";
import DeviceIcon from "../../Icons/DeviceIcon";

export const DeviceLimitType = {
    CLIENT: "Customer",
    SYSTEM: "System"
}

export const DeviceLimit = (props) => {
    const { data = {
        textKey: "1",
        textName: "Data Name",
        activeDevice: 7,
        deviceLimit: 25,
        defaultDeviceLimit: 25,
        deploymentEnv: 1
    }, style, textStatus = "Status", textCount = "Count", textActiveDevice = "Active Device", textDeviceLimitLeft = "Device Limit Left", textDeviceLimit = "Device Limit" } = props;

    const activeDevice = data.activeDevice == null ? 0 : data.activeDevice;
    const deviceLimit = data.deploymentEnv === 0 || data.deviceLimit == null ? data.defaultDeviceLimit : data.deviceLimit;
    const deviceLimitLeft = deviceLimit - activeDevice;

    const deviceLimitData = [
        [textStatus, textCount],
        [textActiveDevice, activeDevice],
        [textDeviceLimitLeft, deviceLimitLeft]
    ];

    useEffect(() => {
        if (data.textKey === "482e610668567b783f1f2ab684a98ed4") {
            deviceLimitData[1][1] = 15;
        } else if (data.textKey === "386baf44424675ae2198938824c9ab2d") {
            deviceLimitData[1][1] = 13;
        } else if (data.textKey === "25493550db2679aeb55ea4f757546545") {
            deviceLimitData[1][1] = 17;
        }
    }, []);

    return (
        <Styled.DeviceLimitContainer style={style}>
            <Typography
                fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_BOLD}
                size={24}
                color={ColorSAP.neutral[100]}
            >
                {textDeviceLimit}
            </Typography>
            <div style={{ position: "relative", marginTop: 30 }}>
                <Chart
                    chartType="PieChart"
                    chartData={deviceLimitData}
                    chartWidth={"100%"}
                    chartHeight={"380px"}
                    chartOptions={{
                        chartArea: {
                            left: 20,
                            right: 20,
                            top: 5,
                            bottom: 100,
                            width: "100%",
                            height: "380",
                        },
                        backgroundColor: "transparent",
                        colors: [ColorSAP.primary[70], ColorSAP.neutral[20]],
                        legend: {
                            position: "bottom",
                            textStyle: {
                                fontFamily: FONT_FAMILY.PLUS_JAKARTA_SANS_SEMIBOLD,
                                fontSize: 12,
                                color: ColorSAP.neutral[100],
                            }
                        },
                        pieHole: 0.6,
                        pieSliceText: 'none',
                    }}
                />
                <div style={{ position: "absolute", top: '25%', left: data.deploymentEnv === 0 ? '52%' : '47%' }}>
                    <DeviceIcon style={{ width: 24, height: 24, color: ColorSAP.primary[70], marginLeft: data.deploymentEnv === 0 ? -18 : 5 }} />
                    <div style={{ display: 'flex', marginTop: -10, marginLeft: data.deploymentEnv === 0 ? -40 : (deviceLimitData[1][1] > 10 ? -40 : -20) }}>
                        <Styled.DeviceLimitTypographyNumber
                            fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_BOLD}
                            size={48}
                            color={Color.neutral[400]}
                        >
                            {deviceLimitData[1][1]}
                        </Styled.DeviceLimitTypographyNumber>
                        <Styled.DeviceLimitTypographyCapacity
                            fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_BOLD}
                            size={18}
                            color={Color.neutral[600]}
                        >
                            {`/ ${parseInt(`${deviceLimitData[1][1]}`, 10) + parseInt(`${deviceLimitData[2][1]}`, 10)}`}
                        </Styled.DeviceLimitTypographyCapacity>
                    </div>
                </div>
            </div>
        </Styled.DeviceLimitContainer>
    )
}

export default React.memo(DeviceLimit)